export default {
  items: [],
  pagination: [],
  item: {},
  car: null
}
